import Vue from "vue";
import VueShepherd from "vue-shepherd";

Vue.use(VueShepherd);
